import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/authProvider';
import { useDefaultRoute } from '../../hooks/useDefaultRoute';

interface PermissionRouteProps {
  resource: string;
  action: string;
  children: React.ReactNode;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  resource,
  action,
  children,
}) => {
  const { isAuthenticated, hasPermission } = useAuth();
  const defaultRoute = useDefaultRoute();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasPermission(resource, action)) {
    if (defaultRoute) {
      return <Navigate to={defaultRoute} replace />;
    }
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};
